import { IModel, Model, ModelRecord } from '@common/models/Model';

export interface IReportingGroupSalesItemModel extends IModel {
  reportingGroupId: number;
  reportingGroupName: string;
  salesItemIds: number[];
}

export class ReportingGroupSalesItemModel
  extends Model
  implements ModelRecord<IReportingGroupSalesItemModel>
{
  reportingGroupId: number;
  reportingGroupName: string;
  salesItemIds: number[];

  constructor(params?: Partial<IReportingGroupSalesItemModel>) {
    super(params);

    this.reportingGroupId = _.defaultTo(params?.reportingGroupId, 0);
    this.reportingGroupName = _.defaultTo(params?.reportingGroupName, '');
    this.salesItemIds = _.defaultTo(params?.salesItemIds, []);
  }
}
